import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';

import { KnBrMyQuoteDownloadLinkComponent } from './kn-br-my-quote-download-link.component';

@NgModule({
  declarations: [KnBrMyQuoteDownloadLinkComponent],
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrStep2CustomerQuoteDownloadLinkComponent: {
          component: () =>
            import('./kn-br-my-quote-download-link.component').then((c) => c.KnBrMyQuoteDownloadLinkComponent),
        },
      },
    } as CmsConfig),
  ],
})
export class KnBrMyQuoteDownloadLinkModule {}
